/** Panel that composes any number of individual filters together,
 * with "AND" combination across them all.
 */

import React from "react";
import { List, OrderedMap, fromJS } from "immutable";
import { withStateHandlers } from "recompose";

import TimeOfDayFilter from "./filters/timeOfDay/TimeOfDayFilter";
import PriceRangeFilter from "./filters/priceRange/PriceRangeFilter";
import StopsFilter from "./filters/stops/StopsFilter";
import AirlinesFilter from "./filters/airlines/AirlinesFilter";

const OfferResponseFilterPanel = ({ offers = List(), requested = List(), filters, updateFilter, view, children }) => (
  <div className="filter-group">
    {children}
    {filters
      .map((f, name) => {
        if (name >= 0) {
          /*IE mapping this differently, need to investigate.*/
          f = f[1]; //f[1] -> Map containing 'ui','fn','view'
        }
        const FilterUI = f.get("ui");
        return f.get("view") === view ? <FilterUI key={name} offers={offers} requested={requested} onFilter={updateFilter.bind(null, name)} /> : null;
      })
      .valueSeq()}
  </div>
);

export default withStateHandlers(
  {
    filters: OrderedMap.of(
      [
        "priceRange",
        fromJS({
          ui: PriceRangeFilter,
          fn: null,
          view: "book-a-flight"
        })
      ],
      [
        "accPriceRange",
        fromJS({
          ui: PriceRangeFilter,
          fn: null,
          view: "get-a-room"
        })
      ],
      [
        "stops",
        fromJS({
          ui: StopsFilter,
          fn: null,
          view: "book-a-flight"
        })
      ],
      [
        "timeOfDay",
        fromJS({
          ui: TimeOfDayFilter,
          fn: null,
          view: "book-a-flight"
        })
      ],
      [
        "airlines",
        fromJS({
          ui: AirlinesFilter,
          fn: null,
          view: "book-a-flight"
        })
      ]
    )
  },
  {
    updateFilter: ({ filters }, { onFilter }) => (filterName, filterFn) => {
      const newFilters = filters.setIn([filterName, "fn"], filterFn);
      const predicates = newFilters.map(f => f.get("fn")).valueSeq();

      // Send new filter fn to parent component
      onFilter(combineAND(predicates));

      // Update state
      return {
        filters: newFilters
      };
    }
  }
)(OfferResponseFilterPanel);

/** Given a list of predicate functions (any of which may be absent)
 * produces a new predicate function that applies AND semantics to
 * all non-null predicates.
 * @param predicates Seq< Optional< Offer -> Bool > >
 * @return Offer -> Bool
 */
const combineAND = predicates => offer => predicates.every(p => p == null || p(offer));



// WEBPACK FOOTER //
// ./src/ndc/offer/OfferResponseFilterPanel.js